import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getProposalsPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/proposal',
  () => {
    return HttpResponse.json([
      {
        id: 'proposalpage',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'ProposalSuggestSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'ProposalHowToSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'ProposalInfoEmailSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'ProposalCategoriesSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'ProposalInstructionLinkSection',
          },
        ],
      },
    ])
  },
)

export const proposalsPageConfigHandlers = [getProposalsPageConfig]
